export var LoadingIndicatorStyle = /*#__PURE__*/function (LoadingIndicatorStyle) {
  LoadingIndicatorStyle["INLINE"] = "inline";
  LoadingIndicatorStyle["OVERLAY"] = "overlay";
  return LoadingIndicatorStyle;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/LoadingIndicator/types.js
// module id = 1495
// module chunks = 11